
import React, { Component } from "react";
import Chart from "react-apexcharts";

class BarChart5 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          id: "basic-bar",  
        },
        colors: ["#2f6bb8", "#e5c853"],
        xaxis: {
          categories: ["Jun", "Jul", "Aug", "Sep"]
        }
      },
     
       series: [
        {
          name: "Acceptance Rate",
          data: [10, 30, 5, 50],
          
        } 
      ]
    };
  }

  render() {
    return (
      <div className="app">
        <div className="row">
          <div className="mixed-chart">
            <Chart
              options={this.state.options}
              series={this.state.series}
              type="line"
              width="380"
              height="280"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default BarChart5;

